import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState, useRef } from 'react';

import { getImage, getData } from '../../helpers/indexedDbHelper';
import { useTranslation } from 'react-i18next';
import { useRefresh } from '../../hooks/useRefresh';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import ListProducts from './ListProducts';
import DrinksScreen from './bar';
import GameScreen from './game/game';
import SpecialsScreen from './specials';
import HappyHourScreen from './happyHour';

function Index({ dishMenu, setShowDetailProduct, setShowListProduct2 }) {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;

  const { dish, alldish } = dishMenu;

  const [dataDish, setDataDish] = useState(dish);
  const [dataDesserts, setDataDesserts] = useState(false);
  const [dataDrinks, setDataDrinks] = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [showGame, setShowGame] = useState(false);

  const [image, setImage] = useState(false);

  const [showListProduct, setShowListProduct] = useState(false);
  const [dishs, setdishs] = useState(false);

  const { change } = useRefresh();
  const [menus, setMenus] = useState([]);

  const [flavors, setFlavors] = useState(dish.flavors);

  const [showSpecials, setShowSpecials] = useState(false);
  const [showSpecials2, setShowSpecials2] = useState(false);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;
      setMenus(data);
    });
  }, [change]);

  useEffect(() => {
    setIsImageLoading(true);
    fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
      if (url) {
        setImage(url);
        setIsImageLoading(false);
      }
    });
  }, [dataDish]);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 307) {
        setDataDesserts(item);
      }
    });
  }, [menus]);

  const fetchImage = async (id) => {
    const imageBlob = await getImage(id);
    if (imageBlob) {
      const imageURL = URL.createObjectURL(imageBlob.data.blob);
      return imageURL;
    }
    return null;
  };

  const navDish = (position) => {
    const menuIndex = alldish.findIndex((item) => item === dataDish);

    let newIndex;
    if (position === 1) {
      newIndex = (menuIndex + 1) % alldish.length;
    } else if (position === -1) {
      newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
    } else {
      return;
    }
    const newDish = alldish[newIndex];
    setDataDish(newDish);
  };

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const delta = touchStartX.current - touchEndX.current;

    if (Math.abs(delta) > 50) {
      if (delta > 0) {
        navDish(1);
      } else {
        navDish(-1);
      }
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 4,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 999,
      }}
    >
      <LayoutContent
        setShowGame={setShowGame}
        showLogo={true}
        setShowListProduct={setShowDetailProduct}
        showFooter={true}
        setShowSpecials={setShowSpecials2}
        goHome={setShowListProduct2}
      >
        <div
          style={{
            position: 'absolute',
            zIndex: 999,
            top: '28%',
            left: 30,
          }}
        >
          <div
            style={{
              width: 45,
              height: 45,
              backgroundColor: '#ED3E08',
              borderRadius: 100,
              borderWidth: 3,
              borderColor: 'white',
            }}
            onClick={() => [navDish(-1)]}
          >
            <img
              style={{
                width: 30,
                height: 30,
                objectFit: 'contain',
                marginTop: 7,
              }}
              src={require('./assets/left23.png')}
            />
          </div>
        </div>

        <div
          style={{
            position: 'absolute',
            zIndex: 999,
            top: '28%',
            right: 30,
          }}
        >
          <div
            style={{
              width: 45,
              height: 45,
              backgroundColor: '#ED3E08',
              borderRadius: 100,
              borderWidth: 3,
              borderColor: 'white',
            }}
            onClick={() => [navDish(1)]}
          >
            <img
              style={{
                width: 30,
                height: 30,
                objectFit: 'contain',
                marginTop: 7,
              }}
              src={require('./assets/right2.png')}
            />
          </div>
        </div>

        <div
          style={{
            overflow: 'scroll',
            height: 800,
            background: '#DFDFDF',
            borderRadius: 30,
          }}
        >
          <div style={{ padding: '10px 20px' }}>
            <img
              src={image}
              style={{
                width: '100%',
                height: 430,
                borderRadius: 35,
                objectFit: 'cover',
                opacity: isImageLoading ? 0 : 1,
                transition: 'opacity 0.5s ease-in-out',
              }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onLoad={() => setIsImageLoading(false)}
            />
            <br />

            <div
              style={{
                padding: 15,
                borderRadius: 20,
                marginTop: -10,
              }}
            >
              <div
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '80%',
                  }}
                >
                  <p
                    className="shor-text-one"
                    style={{
                      fontSize: 32,
                      color: '#6A411C',
                      fontWeight: '900',
                      textAlign: 'left',
                    }}
                  >
                    {langEng
                      ? dataDish.name
                      : translate(
                          i18n.language,
                          dataDish.language,
                          dataDish.name,
                        )}
                  </p>
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    margin: '0px 10px',
                    gap: 10,
                  }}
                >
                  <p
                    style={{
                      fontSize: 24,
                      color: '#572E1A',
                      fontWeight: '900',
                    }}
                  >
                    $
                    {flavors.length === 0 && (
                      <>
                        {dataDish.price > 0
                          ? ` ${dataDish.label_price ?? ''} ${dataDish.price}`
                          : 'Market Price'}
                      </>
                    )}
                  </p>
                </div>
              </div>

              <div>
                <p
                  lineBreakMode="tail"
                  className="shor-text"
                  style={{
                    fontSize: 22,
                    textAlign: 'left',
                    color: 'black',
                    fontWeight: '500',
                  }}
                >
                  {langEng
                    ? `${dataDish.regular_decription.replace(/\\n/g, '\n')}`
                    : `${translateMenu(
                        i18n.language,
                        dataDish.language,
                        dataDish.regular_decription,
                        'regular_decription',
                      )}`}
                </p>
              </div>

              <br />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: 20,
                }}
              >
                <div
                  onClick={() => [
                    setShowListProduct(true),
                    setdishs(dataDesserts),
                  ]}
                  style={{
                    borderRadius: 10,
                    boxShadow: '1px 1px 6px 0 #EFE09E',
                    background: '#ED3E08',
                    justifyContent: 'center',
                    elevation: 1,
                    position: 'relative',
                  }}
                >
                  <img
                    src={require('./assets/desserts.png')}
                    resizeMode={'cover'}
                    style={{
                      width: 300,
                      height: 144,
                      borderRadius: 10,
                      objectFit: 'contain',
                      boderRadius: 20,
                    }}
                  />
                  <p
                    style={{
                      fontWeight: '500',
                      fontFamily: 'Watchtower',
                      fontSize: 30,
                      textAlign: 'center',
                      marginTop: 5,
                      color: '#fff',
                      alignSelf: 'center',
                      textTransform: 'uppercase',
                    }}
                  >
                    DESSERTS
                  </p>
                </div>

                <div
                  onClick={() => [setShowSpecials(true)]}
                  style={{
                    borderRadius: 10,
                    boxShadow: '1px 1px 6px 0 #EFE09E',
                    background: '#ED3E08',
                    elevation: 1,
                    position: 'relative',
                  }}
                >
                  <img
                    src={require('./assets/drinks.png')}
                    resizeMode={'cover'}
                    style={{
                      width: 300,
                      height: 144,
                      borderRadius: 10,

                      objectFit: 'cover',
                      boderRadius: 20,
                    }}
                  />
                  <p
                    style={{
                      fontWeight: '500',
                      fontSize: 30,
                      textAlign: 'center',
                      marginTop: 5,
                      color: '#fff',
                      alignSelf: 'center',
                      textTransform: 'uppercase',
                      fontFamily: 'Watchtower',
                    }}
                  >
                    DRINKS
                  </p>
                </div>
              </div>

              <br />
            </div>
          </div>
        </div>
      </LayoutContent>

      {showGame && <GameScreen setShowListProduct={setShowGame} />}

      {showListProduct && (
        <ListProducts
          dishs={dishs}
          setShowListProduct={setShowListProduct}
          goHome={setShowListProduct2}
        />
      )}
      {showSpecials2 && (
        <SpecialsScreen setShowListProduct={setShowSpecials2} />
      )}

      {showSpecials && (
        <HappyHourScreen
          setShowHappy={setShowSpecials}
          setShowBar={setShowSpecials}
        />
      )}
    </div>
  );
}
export default Index;
